<template>
    <div id="guideline-content" class="citation-guideline">
        <component v-bind:is="guideComponent"></component>
    </div>
</template>

<script>
export default {
    name: "QuickGuide",
    props: ["citationStyle"],
    data: function () {
        return {
            guideComponent: ""
        }
    },
    mounted() {
        const locale = this.$i18n.locale;
        this.guideComponent = () => import(`@/components/newQuickguide/${locale}/${this.citationStyle}`);
    }
}
</script>

<style lang="scss">
.citation-guideline {
    @import "~assets/_guideline";
    display: flex;
    flex-wrap: wrap;
}
</style>


// WEBPACK FOOTER //
// src/components/generator/QuickGuide.vue